import React from "react";
import { connect } from "react-redux";
import { AppState } from "../../../redux";
import $ from "jquery";
import { Person } from "@radivision/graphql/lib/ts/graphql/person";
import { Header } from "./header";
import { FAQ } from "./faq";
import OriginalSeries from "./original-series";
import Mission from "./mission-vision";
import { SignUpCarousel } from "./sign-up-carousel";
import { Identity } from "./identity";
import { RevolutionSection } from "./revolution-section";

interface ComponentProps {
  listCollection: any;
}

interface MapStateProps {
  user: Person | null;
}

export type Props = ComponentProps & MapStateProps;

export const SignUpPageComponent = (props: Props) => {
  React.useEffect(() => {
    $("body").addClass("allow-scroll");
  });

  return (
    <Container>
      <Header />
      <Identity />
      <SignUpCarousel fixedList={{ id: "E59ZC9ZFQqmmvyKop_Ghlg" }} />
      <Mission />
      <OriginalSeries props={props} />
      <FAQ />
      <RevolutionSection />
    </Container>
  );
};

const Container = ({ children }: React.PropsWithChildren<any>) => (
  <div className="getting-started">
    <div className="getting-started-container">{children}</div>
  </div>
);

const mapState = (state: AppState) => ({
  user: state.account.user,
});

const mapDispatch = {};

export const SignUpPage = connect(mapState, mapDispatch)(SignUpPageComponent);
